// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"379":"3533a557","822":"e9374709"}[chunkId] + ".css";
};